// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.6.263",
  "gitHash": "758c3825d12d13a1a060abba465b117fb06c5e72",
  "versionWithHash": "5.6.263-758c3825d12d13a1a060abba465b117fb06c5e72"
};
